<button mat-flat-button class="ci-btn-filter" color="primary" (click)="submit()" matTooltip="Filtrar">
  <mat-icon>search</mat-icon>
</button>
<button mat-stroked-button class="ci-btn-filter" (click)="toggleFiltro()" matTooltip="Abrir Filtros">
  <mat-icon>filter_list</mat-icon>
  Filtros
</button>
<button mat-flat-button class="ci-btn-filter" color="warn" (click)="limpaForm()" matTooltip="Limpar Filtros">
  <mat-icon>delete</mat-icon>
</button>

@if (aberto) {
  <div class="filter-backdrop" (click)="fecharFiltro()"></div>
}

<div class="filter-sidebar mat-elevation-z8" [class.open]="aberto">

  <div class="filter-header d-flex align-items-center justify-content-between px-3 py-3">
    <h3 class="m-0 font-weight-bold">Filtros</h3>
    <button mat-icon-button (click)="fecharFiltro()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="filter-content px-3 py-3">
    <mat-accordion multi>
      @for (filtroSelecionado of filtrosForm.controls; track filtroSelecionado; let i = $index) {
        <mat-expansion-panel
          class="my-1"
          [expanded]="painelAberto(filtroSelecionado)"
          (opened)="abrirPainel(filtroSelecionado)"
          (closed)="fecharPainel(filtroSelecionado)">
          <mat-expansion-panel-header>
            <mat-panel-title class="filtro-titulo">
              <span class="filtro-descricao" [matTooltip]="descricaoFiltro(filtroSelecionado, i)">
                {{ descricaoFiltro(filtroSelecionado, i) }}
              </span>
              <button
                mat-icon-button
                color="warn"
                class="filtro-remover"
                (click)="removerFiltro(i); $event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                matTooltip="Remover condição">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (exibirComposicao(i)) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 dense-field">
              <mat-label>Composição</mat-label>
              <mat-select uiSemItemAtivo [formControl]="filtroSelecionado.get('composicao')">
                <mat-option [value]="'AND'">E</mat-option>
                <mat-option [value]="'OR'">Ou</mat-option>
              </mat-select>
            </mat-form-field>
          }
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 dense-field">
            <mat-label>Campo</mat-label>
            <mat-select uiSemItemAtivo [formControl]="filtroSelecionado.get('propriedade')">
              @for (filtro of filtrosExibidos(); track filtro) {
                <mat-option [value]="filtro.propriedade">
                  {{filtro.descricao}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 dense-field">
            <mat-label>Condição</mat-label>
            <mat-select uiSemItemAtivo [formControl]="filtroSelecionado.get('condicao')">
              @for (condicao of condicoesFiltradas(filtroSelecionado.get('propriedade').value); track condicao) {
                <mat-option
                  [value]="condicao.valor">
                  {{condicao.descricao}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (exibirCampoPadrao(filtroSelecionado)) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 dense-field">
              <mat-label>Valor</mat-label>
              <input matInput required placeholder="Digite o valor..." [formControl]="filtroSelecionado.get('termo')" />
            </mat-form-field>
          }
          @if (exibirCampoBooleano(filtroSelecionado)) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 dense-field">
              <mat-label>Valor</mat-label>
              <mat-select uiSemItemAtivo required [formControl]="filtroSelecionado.get('termo')">
                <mat-option [value]="'True'">Sim</mat-option>
                <mat-option [value]="'False'">Não</mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if (exibirCampoData(filtroSelecionado)) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 dense-field">
              <mat-label>Data</mat-label>
              <input matInput required [matDatepicker]="picker" [formControl]="filtroSelecionado.get('termo')" placeholder="dd/mm/aaaa">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          }
          @if (exibirOptions(filtroSelecionado)) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 dense-field">
              <mat-label>Selecione</mat-label>
              <mat-select uiSemItemAtivo required [formControl]="filtroSelecionado.get('termo')">
                @for (opcao of options(filtroSelecionado.get('propriedade').value); track opcao) {
                  <mat-option [value]="opcao.valor">
                    {{opcao.texto}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
    <div class="text-right mt-3">
      <button mat-flat-button color="accent" (click)="adicionarFiltro()">
        <mat-icon>add</mat-icon> Adicionar Condição
      </button>
    </div>
  </div>

  <div class="filter-footer p-3 border-top d-flex justify-content-end">
    <button mat-flat-button color="warn" class="mr-2" (click)="limpaForm()">
      <mat-icon>delete</mat-icon>
      Limpar
    </button>
    <button mat-flat-button color="primary" (click)="submit()">
      <mat-icon>search</mat-icon>
      Pesquisar
    </button>
  </div>
</div>
